var map = {
	"./black/renwutongbu2.png": "s9Wv",
	"./blue/renwutongbu2.png": "QitE",
	"./white/renwutongbu2.png": "H4XK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tekY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/renwutongbu2\.png$
// module id = tekY
// module chunks = 24